module.exports = __webpack_public_path__ + "static/media/deepak.4a326ef6.jpg";